import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import Markdown from "markdown-to-jsx";
import Lottie from "lottie-react";
import colorfulConfettiAnimation from "@/common/lottie/ColorfulConfettiBrust.json";
var WarrantyExtendedCard = function WarrantyExtendedCard(_ref) {
  var warrantyPriceDetailsV3 = _ref.warrantyPriceDetailsV3;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 p-3 rounded-lg w-full",
    style: {
      backgroundImage: "linear-gradient(-68deg, rgb(255, 210, 94) 10%, rgb(227, 182, 67) 99%)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F4EDFC] flex items-center justify-center overflow-hidden px-2 rounded-[36px] w-[81px] py-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-bold text-[10px] text-[#0D0DB5] whitespace-nowrap"
  }, tShort("warranty/badge", {
    ns: "web_tracking"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "bg-[#FBFBFB] rounded-lg p-2 py-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 "
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add-moderator-outline-rounded",
    className: "text-violet shrink-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center gap-1 min-w-0"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-medium leading-6 text-[#00143C] whitespace-nowrap"
  }, tShort("remaining/car_warranty", {
    ns: "web_tracking"
  })), warrantyPriceDetailsV3.title ? /*#__PURE__*/React.createElement(Markdown, {
    className: "text-sm font-medium  leading-6",
    options: {
      overrides: {
        strong: {
          props: {
            style: {
              color: warrantyPriceDetailsV3.text_color || undefined,
              backgroundColor: warrantyPriceDetailsV3.highlight_background || undefined
            }
          }
        }
      }
    }
  }, warrantyPriceDetailsV3.title) : null)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Lottie, {
    animationData: colorfulConfettiAnimation,
    loop: true,
    className: "w-10 h-10 shrink-0"
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-normal text-xs leading-4 text-[#0D0DB5] tracking-[-0.3px]"
  }, tShort("warranty/protected_description", {
    ns: "web_tracking"
  })))));
};
export default WarrantyExtendedCard;